import axiosInstance from './instance';

const inboxApi = {
  // 인박스 목록 - (inbox list)
  // https://dev.clp.kr/spc/api/static/docs/front/front-inbox.html#resources-learner-inbox-fetch
  inboxList(params: { read?: boolean; categoryId?: string }) {
    return axiosInstance.get(`/learner/inbox`, { params });
  },
  // * 인박스 삭제 (delete inbox)
  // https://dev.clp.kr/anchor/api/static/docs/front/front-inbox.html#resources-learner-inbox-remove
  deleteInbox(id: string) {
    return axiosInstance.delete(`/learner/inbox/${id}`);
  },

  // 인박스 읽음 처리 - (inbox read)
  // https://dev.clp.kr/anchor/api/static/docs/front/front-inbox.html#resources-learner-inbox-read
  inboxRead(id: string) {
    return axiosInstance.put(`/learner/inbox/category/${id}/read`);
  },
};

export default inboxApi;
